/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AccountRegister {
  mitId: string;
  email: string;
  first: string;
  last: string;
  type?: "affiliate" | "grad";
}

export interface AccountRegisterResponse {
  /** Deep link used for account registration (Account Registration Application) */
  registrationUrl?: string;
}

export interface AccountRegisterExtend {
  mitId?: string;
  /** Extend to date, undefined/null for no expiry */
  dateEnd?: string;
  type?: "affiliate";
}

export interface Affiliate {
  dlcKey?: string;
  endDate?: string;
  statusComment?: string;
}

export type Roles = {
  roleName?: string;
  enabled?: boolean;
}[];

export interface CreateMoiraAccountRequest {
  correlationId: string;
  mitId: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  dob: string;
  email: string;
  ccEmail?: string;
  moiraClass: string;
  sponsorKrbName: string;
  sendAccountRegistrationEmail?: boolean;
  emailTemplate?: string;
  international?: boolean;
}

export interface CreateMoiraAccountResponse {
  mitId: string;
  existingAccount: boolean;
  registrationEmailSent: boolean;
  krbName?: string;
  moiraAccountStatus?: number;
}

export interface CardsData {
  mobileIdActive: boolean;
  mobileIdStatusMessage: string;
  mobileIdIOSMobileActive: boolean;
  mobileIdIOSWatchActive: boolean;
  mobileIdAndroidMobileActive: boolean;
  mitCardActive: boolean;
  mitCardStatusMessage: string;
}

export interface CSGoldUser {
  patronId: number;
  homeAddress1?: string | null;
  homeAddress2?: string | null;
  homeAddress3?: string | null;
  homeAddress4?: string | null;
  homeCity?: string | null;
  homeState?: string | null;
  homeZip?: string | null;
  homeCountry?: string | null;
  homePhone?: string | null;
  localAddress1?: string | null;
  localAddress2?: string | null;
  localAddress3?: string | null;
  localAddress4?: string | null;
  localCity?: string | null;
  localState?: string | null;
  localZip?: string | null;
  localCountry?: string | null;
  localPhone?: string | null;
  email?: string | null;
  imagePath?: string | null;
  pinExpiration?: string | null;
  local?: string | null;
  localVendingLimit?: number | null;
  localWebAccess?: number | null;
  localDept?: string | null;
  localPos?: string | null;
  localAffilId?: string | null;
  localComment?: string | null;
  localClearance?: string | null;
  localStartDate?: string | null;
  localEndDate?: string | null;
  localSponsor?: string | null;
  localClass?: string | null;
  localIsActive?: string | null;
  localIsEmp?: string | null;
  localMajor?: string | null;
  localIsEligible?: string | null;
  localIsRegistered?: string | null;
  localRegType?: string | null;
  localSeparationDate?: string | null;
  localCurrentHold?: string | null;
  localCCureEndDate?: string | null;
  localCardLastModified?: string | null;
  localCardCreated?: string | null;
  localImageDate?: string | null;
  localTitle?: string | null;
  localPrefName?: string | null;
  localCred?: string | null;
  localSendToCCure?: string | null;
  occupancyStart?: string | null;
  occupancyEnd?: string | null;
  siteName?: string | null;
  siteId?: string | null;
  buildingName?: string | null;
  buildingId?: string | null;
  floorName?: string | null;
  floorId?: string | null;
  suiteName?: string | null;
  suiteId?: string | null;
  roomName?: string | null;
  roomId?: string | null;
  localKerbId?: string | null;
  localMRGroup?: string | null;
  localMRExpire?: string | null;
  localHMSMP?: string | null;
  localCurrentVarSport?: string | null;
  localInstCode?: string | null;
  localTPassNumber?: string | null;
  localStuDownloadDate?: string | null;
  localEmpDownloadDate?: string | null;
  localAlumDownloadDate?: string | null;
  localHRAct?: string | null;
  localKrbClass?: string | null;
  localKrbDept?: string | null;
  localKrbUpdate?: string | null;
  localDormRoom?: string | null;
  localHomeAddr1Ody?: string | null;
  localHomeAddr2Ody?: string | null;
  localHomeStateOdy?: string | null;
  localHomeZipOdy?: string | null;
  localHomeCountry?: string | null;
  localRegEndEarlyDate?: string | null;
  localRegEndEarlyReason?: string | null;
  localUgOriginalClassYear?: string | null;
  localUgCurrentClassYear?: string | null;
  localHomeCityOdy?: string | null;
  localSendToHMS?: string | null;
  localTerm?: string | null;
  localTerm1?: string | null;
  localTerm2?: string | null;
  localTermStatus?: string | null;
  localTermStatus1?: string | null;
  localTermStatus2?: string | null;
  localRegGroup?: string | null;
  localIsNewGrad?: string | null;
  localUgTermComp?: string | null;
  localIsDegreeCand?: string | null;
  localDegreeCandTerm?: string | null;
  localGradTermComp?: string | null;
  localCurPlus1RegType?: string | null;
  localCurPlus2RegType?: string | null;
  localPidm?: string | null;
  localLegalFName?: string | null;
  localLegalMName?: string | null;
  localLegalLName?: string | null;
  localCCureHousing?: string | null;
  localTempId?: string | null;
  localAccessMitOptOut?: string | null;
  localMyCardLogin?: string | null;
  localProxNum?: string | null;
  localPrefName2?: string | null;
  localIsDeceased?: string | null;
  localEmsNum?: string | null;
  localEmsExp?: string | null;
  localSponsorId?: string | null;
  localMobileCred1Status?: number | null;
  localMobileCred2Status?: number | null;
  localCovidCCure9000?: number | null;
  localCovidCCure800?: number | null;
  localCovidCCure9000Str?: string | null;
  localCovidCCure800Str?: string | null;
  localHmsSpouseDOB?: string | null;
  localHmsSpouseFirst?: string | null;
  localHmsSpouseLast?: string | null;
  localCCureEDateLegacy?: string | null;
  localHmsNonAccess?: string | null;
  localEligibleBadge?: string | null;
  localHmsFamilySponsor?: string | null;
  localMobileCred3Status?: number | null;
  localMobileCred4Status?: number | null;
  localMobileRole?: string | null;
  localMobileOrgLabel?: string | null;
  localMobileOrgValue?: string | null;
  localMealPlanStatus?: string | null;
  localMealTerm?: string | null;
  lastTranLocation?: number | null;
  lastTranDate?: string | null;
  lastTranError?: number | null;
  localAtlasSponsorEmail?: string | null;
  localAtlasSponsorDept?: string | null;
  localAtlasSpnsrAccessDate?: string | null;
}

export interface DepartmentGroups {
  affiliates: Departments;
  staff: Departments;
  student?: Departments;
}

export type Departments = Department[];

export interface Department {
  dlcKey?: string;
  departmentName?: string;
}

export interface DuoEnroll {
  platform: "generic smartphone" | "apple ios" | "google android";
}

export interface DuoEnrollResponse {
  activationUrl?: string;
  activationCode?: string;
  activationBarcode?: string;
  activationQrCode?: string;
  installationUrl?: string;
  validSecs?: number;
}

export interface DuoReset {
  mitId: string;
}

export interface DuoSignedRequest {
  signedRequest?: string;
  hostname?: string;
}

export interface DuoUserStatus {
  username: string;
  enrolled: boolean;
  hasDevices: boolean;
}

export type Emails = EmailPerson[];

export interface Filters {
  hierarchy?: Hierarchy;
}

export type Hierarchy = {
  qualifier_code?: string;
  qualifier_name?: string;
  children?: {
    qualifier_code?: string;
    qualifier_name?: string;
    children?: object[];
  }[];
}[];

export interface Invite {
  sessionId?: string;
  invitee?: string;
  kerberos?: string;
  mitId?: string;
  inviteDate?: string;
  stats?: InviteStats;
  latestUpdate?: string;
  emailSentTo?: string;
}

export interface InviteStats {
  invited?: boolean;
  kerbDone?: boolean;
  passwordDone?: boolean;
  duoDone?: boolean;
  pictureDone?: boolean;
}

export interface PageFilters {
  affiliates?: {
    invites?: string[];
  };
  staff?: {
    departments?: string[];
  };
  students?: {
    semesters?: string[];
  };
  visitors?: {
    types?: string[];
  };
}

export type Permissions = {
  permission?: string;
  enabled?: boolean;
}[];

export interface PictureRejectReasonsRes {
  reasons?: PictureRejectReasons;
}

export type PictureRejectReasons = string[];

export interface KerbAvailable {
  available?: boolean;
}

export interface KerbCreate {
  krbName: string;
}

export type KerbSuggestions = string[];

export interface InviteRevoke {
  mitId: string;
}

export type StatusFilters = StatusFilter[];

export interface StatusFilter {
  id: number;
  key: string;
  filterKey: string;
}

export interface SessionListItem {
  sessionId?: string;
  invitee: string;
  kerberos: string;
  mitId: string;
  inviteDate: string | null;
  stats: SessionListItemStats;
  latestUpdate: string | null;
  emailSentTo: string;
  expiryDate: string | null;
  affiliation: string;
  sponsor?: Sponsor;
  type: string;
  permissions: SessionListItemPermissions;
}

export interface SessionListItemPermissions {
  canChangeNonMitEmail: boolean;
  canChangeName: boolean;
  canChangeDOB: boolean;
  canResendInvite: boolean;
  canResetKerberos: boolean;
  canResetPassword: boolean;
  canResetDUO: boolean;
  canReviewProfilePic: boolean;
  canViewOnboardingProgress: boolean;
  canViewMobileIDStatus: boolean;
  canViewMitIdCardStatus: boolean;
  canUpdateSponsor: boolean;
  canUpdateDLC: boolean;
  canUpdateExpiryDate: boolean;
  canRevoke: boolean;
  canSuspend: boolean;
  canViewHistory: boolean;
  canCreateNewAccount: boolean;
}

export interface SessionListItemStats {
  invited: boolean;
  kerbDone: boolean;
  passwordDone: boolean;
  duoDone: boolean;
  pictureDone: boolean;
  expired: boolean;
  revoked: boolean;
  suspended: boolean;
  mobileId: boolean;
  card: boolean;
}

export interface SessionsResponse {
  sessionList: SessionListItem[];
  stats: Stats;
}

export interface Suspend {
  mitId: string;
}

export interface VisitorsResponse {
  visitorsList: VisitorsListItem[];
}

export interface VisitorsListItem {
  active: boolean;
  invitee: string;
  mitId: string;
  inviteDate: string;
  invitationsCount: number;
  latestInvitor: string;
  type: string;
  stats: VisitorsListItemStats;
  expiryDate: string;
}

export interface VisitorsListItemStats {
  invited: boolean;
  accepted: boolean;
  pictureDone: boolean;
  eventDone: boolean;
}

export interface SignedUrl {
  url?: string;
  id?: string;
}

export interface PictureValidate {
  success: boolean;
  message?: string;
}

export type Sponsors = Sponsor[];

export interface Sponsor {
  mitId: string;
  firstName: string;
  lastName: string;
  email?: string;
  dlc: string;
  kerberos: string;
}

export interface SponsorUpdate {
  mitId: string;
  sponsorMitId: string;
  dlcKey: string;
}

export interface Status {
  krbName?: string;
  mitId?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  nextStep?:
    | "kerb"
    | "password"
    | "duo"
    | "picture"
    | "completed"
    | "completed_onboarding";
  accountStatusCode?: string;
  accountStatusName?: string;
  steps?: string[];
  skippableSteps?: string[];
}

export interface PasswordStatus {
  krbName?: string;
  isSet?: boolean;
}

export interface PasswordChange {
  password?: string;
  currentPassword?: string;
}

export interface PasswordReset {
  mitId: string;
}

export interface BadRequestResponse {
  message?: string;
}

export interface PasswordSet {
  password?: string;
}

export interface EmailPerson {
  mitId?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  emailAddress?: string;
  emailTemplate?: string;
}

export interface ProfilePicturePerson {
  mitId?: string;
  image?: string;
  dateCreated?: string;
  status?: string;
}

export interface ProfilePicturePut {
  mitId?: string;
  status?: string;
  rejectReasons?: string[];
}

export interface Stats {
  users: number;
  ready: number;
  mobileIdDone: number;
  mitIdCardDone: number;
  dailyStats: StatsForDay[];
}

export interface StatsForDay {
  day: string;
  invited?: number;
  kerbDone: number;
  passwordDone: number;
  duoDone: number;
  pictureDone: number;
}

export interface TestTokenResponse {
  token?: string;
  shortlink?: string;
}

export interface TestKrb5Response {
  krbName: string;
  available: boolean;
  message: string;
}

export interface TestCreateMit {
  mitId?: string;
}

export interface TestCreateMitRequest {
  firstName?: string;
  lastName?: string;
  middleName?: string;
  email?: string;
  /** mmdd */
  dob?: string;
}

export interface TestReset {
  mitId?: string;
}

export type TestUsers = TestUser[];

export interface TestUser {
  firstName?: string;
  lastName?: string;
  middleName?: string;
  mitId?: string;
  email?: string;
  krbName?: string;
  nextStep?: string;
}

export type Texts = Text[];

export interface Text {
  textId?: string;
  type?: string;
  text?: string;
  target?: string;
}

export interface TokenEmail {
  emailAddress?: string;
}

export interface MobileIdProfile {
  hasPhoto: boolean;
  hasActiveMobileId: boolean;
  canLinkUnlink: boolean;
  activeDevices: {
    physicalCard: boolean;
    applePhone: boolean;
    appleWatch: boolean;
    androidPhone: boolean;
  };
  deviceStatus: {
    applePhone: DeviceStatus;
    appleWatch: DeviceStatus;
    androidPhone: DeviceStatus;
  };
  hasMobileIdOnOtherDevice?: boolean;
}

export interface DeviceStatus {
  id?: number;
  text?: string;
}

export interface MobileIdRecord {
  deviceModel: string;
  deviceOS: string;
  platform: "IOS" | "ANDROID";
  appId: string;
}

export interface CBordAndroidRequest {
  deviceManufacturer?: string;
  deviceModel?: string;
  deviceOSVersion?: string;
}

export interface CBordAndroidResponse {
  session_id?: string;
  externalAuthenticationToken?: string;
  authorizationBlob?: CBordAuthBlobObject;
  passes?: CBordPasses;
  credStatus?: CBordCredStatus;
  credentials?: CBordCredential[];
  referenceIdentifier?: string;
  exception?: string;
  photoStatus?: "noPhoto" | "processing" | "hasPhoto" | "rejected";
  patronDetail?: CBordPatronDetail;
}

export interface CBordAuthBlobObject {
  patronData?: string;
  clientIdentifier?: string;
  signature?: string;
}

export interface CBordPasses {
  iPhone?: number;
  iWatch?: number;
  androidHID?: number;
  androidNXP?: number;
}

export interface CBordCredStatus {
  iPhone?: number;
  iWatch?: number;
  androidHID?: number;
  androidNXP?: number;
}

export interface CBordCredential {
  id?: string;
  issuer?: string;
  issuerToken?: string;
  invitationId?: string;
  invitationCode?: string;
}

export interface CBordAuthRequest {
  deviceModel?: string;
  deviceOSVersion?: string;
}

export interface CBordAuthResponse {
  session_id?: string;
  authorizationBlob?: CBordAuthBlobObject;
  passes?: CBordPasses;
  credStatus?: CBordCredStatus;
  credentials?: CBordCredential[];
  referenceIdentifier?: string;
  exception?: string;
  externalAuthenticationToken?: string;
  photoStatus?: "noPhoto" | "processing" | "hasPhoto" | "rejected";
}

export interface CBordCredentialUpdateRequest {
  externalAuthenticationToken: string;
  referenceIdentifier: string;
  device: CBordAndroidDevice;
  authorizationBlob: CBordAuthBlobObject;
}

export interface CBordCredentialDeleteRequest {
  externalAuthenticationToken: string;
  authorizationBlob: CBordAuthBlobObject;
}

export interface CBordCredentialResponse {
  passes?: CBordPasses;
  credStatus?: CBordCredStatus;
  exception?: string;
}

export interface CBordCredentialItem {
  id?: string;
  issuer?: string;
  issuerToken?: string;
  invitationId?: string;
  invitationCode?: string;
}

export interface CBordAndroidDevice {
  manufacturer?: string;
  model?: string;
  osVersion?: string;
}

export interface CBordPatronDetail {
  patronId?: string;
  dbdEmail: string;
  localMobileRole?: string;
  localMobileOrgLabel?: string;
  localMobileOrgValue?: string;
  requiresCredSetup?: boolean;
  requiresMapping?: boolean;
}

export interface UserPicture {
  hasPicture: boolean;
  url?: string;
  status?: string;
}

export interface UserMitIdCard {
  isCardValid: boolean;
}

export interface Session {
  mitId: string;
  firstName: string;
  lastName: string;
  type: string;
  department: string;
  invited: boolean;
  inviteDate: string;
  inviteEmail: string;
  kerbDone: boolean;
  kerbDoneDate: string;
  kerbName: string;
  passwordDone: boolean;
  passwordDoneDate: string;
  duoDone: boolean;
  duoDoneDate: string;
  pictureDone: boolean;
  pictureDoneDate: string;
  onboardingEnabled: boolean;
  onboardingTasksCompleted: number;
  onboardingTasksTotal: number;
  onboardingCompletedPercentage: number;
  onboardingStatus: string;
  mobileIdDone: boolean;
  mobileIdDoneDate: string;
  mitIdCardDone: boolean;
  mitIdCardDoneDate: string;
  expired: boolean;
  expiryDate: string;
  sponsor?: Sponsor;
  extraInfo?: string[];
  history: SessionHistoryItem[];
  permissions: SessionListItemPermissions;
}

export interface SessionHistoryItem {
  eventDate?: string;
  type?: string;
  changedBy?: string;
  comment?: string;
}

export interface LookupValue {
  id: string;
  name: string;
  krb_name?: string;
  old_name?: string;
}

export interface VisitorInvite {
  /**
   * identifier for invite
   * @example "aaaaaaaa-aaaa-aaaa-aaaa-92954f8b36f7"
   */
  id: string;
  invited: boolean;
  /** @example "Jane" */
  inviter: string;
  invitee: string;
  /** @example "099999999" */
  contactNumber?: string;
  /** @example "test@test.test" */
  emailAddress: string;
  /** @example "6999999" */
  mitId: string;
  /** @example true */
  acceptedAcknowledgement: boolean;
  /** @example true */
  attestationCompleted: boolean;
  /** @example "2021-03-15" */
  inviteCreationDate: string;
  /** @example "2021-03-15" */
  inviteValidFrom?: string;
  /** @example "2021-03-22" */
  inviteExpiryDate?: string;
  /** @example true */
  active?: boolean;
  /** @example "ACCESS" */
  inviteType: string;
  /** @example "aaaaaaaa-aaaa-aaaa-aaaa-92954f8b36f7" */
  eventId?: string;
  /** @example "Book Club" */
  eventName?: string;
  pictureDone: boolean;
  covidMedicalStatus: boolean;
  vaccinationStatus: boolean;
  activeInvitations: VisitorInvitesHistoryItem[];
  invitationHistory: VisitorInvitesHistoryItem[];
}

export interface VisitorInvitesHistoryItem {
  fromDate: string;
  untilDate: string;
  invitedBy: string;
  inviteType: string;
  endReason?: string;
}

export interface StatusVcs {
  mit_id: string;
  kerberos_id: string;
  id_car: string;
}

export interface ExtendedPersonVcs {
  id: string;
  krb_name: string;
  organization: string;
  phone: string;
  email: string;
  dob: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  first_name: string;
  last_name: string;
}

export interface Building {
  id: string;
  number: string;
  name?: string;
  name_long?: string;
}

export interface VCS {
  id?: string;
  status?: StatusVcs;
  sponsor?: LookupValue;
  person?: ExtendedPersonVcs;
  department?: LookupValue;
  buildings?: Building[];
  endDate?: string;
  officeAddress?: string;
  costObject?: string;
  reasonForAccess?: string;
  paidByMit?: boolean;
  dailyHealthCheck?: boolean;
  existingMitid?: boolean;
  photo?: boolean;
  enforce_medical?: boolean;
  startDate?: string;
  request_mit_medical?: boolean;
  mitidCardNeeded?: boolean;
  mitidDeliveryMethod?: string;
  can_edit?: boolean;
  updated_by?: string;
  updated_on?: string;
  status_comments?: string;
}

export interface UserProfile {
  mitId?: string;
  krbName: string;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  department: string;
}

export interface SponsoredAccount {
  /** @example 984747811 */
  mitId: string;
  /** @example "jweekley" */
  krbName: string;
  /** @example "Bob Ross" */
  name: string;
  /** @example "GUEST24M" */
  moiraClass: string;
  /** @example "test@gmail.com" */
  alternativeEmail: string;
}

export type SponsoredGuestCreated = SponsoredGuestOverview[];

export interface SponsoredGuestOverview {
  /** @example 984747811 */
  mitId: string;
  /** @example "jweekley" */
  krbName: string;
  /** @example "Bob Ross" */
  name: string;
  /** @example "2022-06-05T00:00:00.000Z" */
  startDate: string;
  /** @example "2023-01-01T00:00:00.000Z" */
  endDate: string;
  /** @example true */
  moiraAccountCreated: boolean;
  /** @example 1 */
  moiraStatus?: number;
  /** @example "Epi-Use" */
  organization?: string;
  /** @example true */
  canRenew?: boolean;
  /** @example false */
  hasBeenRenewed?: boolean;
  /** @example true */
  pendingSponsorReassignmentRequest?: boolean;
}

export interface ReassignedSponsoredAccount {
  mitId: string;
  krbName: string;
  name: string;
  status: "PENDING" | "APPROVED" | "REJECTED";
  requestor: {
    mitId?: string;
    krbName?: string;
    name?: string;
  };
}

export interface SponsorGuestReassignApproval {
  status?: "PENDING" | "APPROVED" | "REJECTED";
}

export interface SponsoredGuestNewSponsor {
  mitId: string;
  newSponsorMitId: string;
  status?: "PENDING" | "APPROVED" | "REJECTED";
}

export interface SponsoredGuest {
  isSponsor: boolean;
  costObject?: string;
  sponsor?: SponsorInformation | null;
  department?: Lookup | null;
  guest: GuestInformation;
  access: AccessInformationGuest;
}

export interface SponsoredSpouse {
  spouse: GuestInformation;
  access: AccessInformationSpouse;
}

export interface SponsoredGuestAdditionalDetails {
  moiraStatus: number;
  alternativeEmail?: string;
  hasSponsorReassignmentRequest: boolean;
}

export interface SponsorInformation {
  id: string;
  name: string;
}

export interface RenewSponsoredAccountRequest {
  krbNames: string[];
}

export interface SponsoredGuestReassign {
  status: "PENDING" | "APPROVED" | "REJECTED";
}

export interface GuestInformation {
  firstName: string;
  lastName: string;
  existingMitId?: string;
  dob: string;
  externalOrg?: string;
  email: string;
  phone: string;
}

export interface AccessInformationGuest {
  /** In format YYYY-MM-DD */
  startDate: string;
  /** In format YYYY-MM-DD */
  endDate: string;
  accessReason?: string;
  paidByMit?: boolean;
  requireCampusAccess?: boolean;
}

export interface AccessInformationSpouse {
  startDate: string;
  endDate: string;
}

export interface SponsoredAccountAuths {
  canCreateGuest: boolean;
  canCreateSpouse: boolean;
  canRenew: boolean;
}

export interface SponsoredAccountStepStatus {
  registrationStatuses: RegistrationStatuses;
}

export interface RegistrationStatus {
  /** @example 2 */
  stepId: number;
  /** @example "kerb | password | duo | picture" */
  description: string;
  /** @example 0 */
  complete: boolean;
}

export type RegistrationStatuses = RegistrationStatus[];

export interface Lookup {
  /** @example "D_IS&T" */
  id: string;
  /** @example "Information Service & Technology" */
  name: string;
}

export type Lookups = Lookup[];

export interface ApiHealthPingResponse {
  service: {
    name: string;
    version: string;
  };
  deployment: {
    region: string;
  };
  stage: {
    name: string;
  };
}

export interface ApiStatusResponse {
  service: {
    name?: string;
    version?: string;
  };
  deployment: {
    region?: string;
  };
  stage: {
    name?: string;
  };
  status: string;
  dependencies: {
    name: string;
    status: string;
    message?: string;
  }[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://global.api.mit.edu/account/v2";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Account API
 * @version 1.0.8
 * @baseUrl https://global.api.mit.edu/account/v2
 */
export class AccountApi<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  admin = {
    /**
     * No description
     *
     * @tags Admin
     * @name DepartmentsList
     * @summary Get departments
     * @request GET:/admin/departments
     * @secure
     */
    departmentsList: (params: RequestParams = {}) =>
      this.request<DepartmentGroups, any>({
        path: `/admin/departments`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name EmailList
     * @summary Get all emails that went out or should go out
     * @request GET:/admin/email
     * @secure
     */
    emailList: (
      query?: {
        /** return all emails or only outstanding */
        all?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Emails, any>({
        path: `/admin/email`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name EmailCsvList
     * @summary Get all emails that went out or should go out in csv
     * @request GET:/admin/email/csv
     * @secure
     */
    emailCsvList: (
      query?: {
        /** return all emails or only outstanding */
        all?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Emails, any>({
        path: `/admin/email/csv`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Create a Moira account and then initiates the process for creating a Kerberos account.  This is an asynchronous process and an event will be published once completed.
     *
     * @tags Admin
     * @name MoiraAccountCreate
     * @summary Create a Moira account
     * @request POST:/admin/moira/account
     * @secure
     */
    moiraAccountCreate: (
      data: CreateMoiraAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateMoiraAccountResponse, BadRequestResponse>({
        path: `/admin/moira/account`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name FiltersList
     * @summary get the UI filters for this user
     * @request GET:/admin/filters
     * @secure
     */
    filtersList: (params: RequestParams = {}) =>
      this.request<Filters, any>({
        path: `/admin/filters`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name FiltersStatusList
     * @summary get the UI status filters
     * @request GET:/admin/filters/status
     * @secure
     */
    filtersStatusList: (params: RequestParams = {}) =>
      this.request<StatusFilters, any>({
        path: `/admin/filters/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name PermissionsList
     * @summary get the permissions for this user
     * @request GET:/admin/permissions
     * @secure
     */
    permissionsList: (
      query?: {
        /** Add the mitId if you need the permissions for your Kerb on this mitId */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Permissions, any>({
        path: `/admin/permissions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Picture
     * @name PictureList
     * @summary Return picture for user with specified mitId
     * @request GET:/admin/picture
     * @secure
     */
    pictureList: (
      query: {
        /** Return picture for user with specified mitId */
        mitId: string;
        /** Specify the image resolution. */
        resolution?: "low" | "high";
      },
      params: RequestParams = {},
    ) =>
      this.request<ProfilePicturePerson, any>({
        path: `/admin/picture`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Picture
     * @name PictureUpdate
     * @summary Approve or reject a pending profile picture
     * @request PUT:/admin/picture
     * @secure
     */
    pictureUpdate: (data: ProfilePicturePut, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/picture`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Picture
     * @name PictureDetail
     * @summary Get a user picture with status
     * @request GET:/admin/picture/{mitId}
     * @secure
     */
    pictureDetail: (
      mitId: string,
      query?: {
        /** Specify the image resolution. */
        resolution?: "low" | "high";
      },
      params: RequestParams = {},
    ) =>
      this.request<UserPicture, any>({
        path: `/admin/picture/${mitId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Picture
     * @name PictureRejectReasonsList
     * @summary Get reject reasons for picture
     * @request GET:/admin/picture/reject-reasons
     * @secure
     */
    pictureRejectReasonsList: (params: RequestParams = {}) =>
      this.request<PictureRejectReasons, void>({
        path: `/admin/picture/reject-reasons`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Picture
     * @name PictureUrlDetail
     * @summary Get presigned url to put a cropped picture for mitid
     * @request GET:/admin/picture/url/{mitId}
     * @secure
     */
    pictureUrlDetail: (mitId: string, params: RequestParams = {}) =>
      this.request<SignedUrl, void>({
        path: `/admin/picture/url/${mitId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Picture
     * @name PictureUploadUrlList
     * @summary Get presigned url to put a picture to be processed by ML
     * @request GET:/admin/picture/upload-url
     * @secure
     */
    pictureUploadUrlList: (
      query: {
        /** Return picture for user with specified mitId */
        mitId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SignedUrl, void>({
        path: `/admin/picture/upload-url`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Will check mit id in payload if account may be registered. States needs to be 0,2 or 8
     *
     * @tags Admin
     * @name RegisterCreate
     * @summary register - Send email to a new account and create account session
     * @request POST:/admin/register
     * @secure
     */
    registerCreate: (
      data: AccountRegister,
      query?: {
        /**
         * Will not send out any notifications related to account registration. Can use deep link from response body to forward use to account registration
         * @example true
         */
        embeddedRegistration?: string;
        /**
         * Will not send out any notifications related to account registration. Can use deep link from response body to forward use to account registration. All lower case for SAP use case
         * @example true
         */
        embeddedregistration?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AccountRegisterResponse, BadRequestResponse>({
        path: `/admin/register`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description sends registration email to person if success
     *
     * @tags Admin
     * @name RegisterExtendUpdate
     * @summary extend an existing account
     * @request PUT:/admin/register/extend
     * @secure
     */
    registerExtendUpdate: (
      data: AccountRegisterExtend,
      params: RequestParams = {},
    ) =>
      this.request<void, BadRequestResponse>({
        path: `/admin/register/extend`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ResetDuoUpdate
     * @summary Reset duo by deleting all user devices
     * @request PUT:/admin/reset/duo
     * @secure
     */
    resetDuoUpdate: (data: DuoReset, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/reset/duo`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description reset a user password
     *
     * @tags Admin
     * @name ResetPasswordUpdate
     * @summary reset user password
     * @request PUT:/admin/reset/password
     * @secure
     */
    resetPasswordUpdate: (data: PasswordReset, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/reset/password`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name RolesList
     * @summary get the admin roles for this user
     * @request GET:/admin/roles
     * @secure
     */
    rolesList: (params: RequestParams = {}) =>
      this.request<Roles, any>({
        path: `/admin/roles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name RevokeUpdate
     * @summary Revoke an invite
     * @request PUT:/admin/revoke
     * @secure
     */
    revokeUpdate: (data: InviteRevoke, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/revoke`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name RevokeInitiationUpdate
     * @summary Revoke an invite
     * @request PUT:/admin/revoke-initiation
     * @secure
     */
    revokeInitiationUpdate: (data: InviteRevoke, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/revoke-initiation`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SessionsList
     * @summary Get sessions
     * @request GET:/admin/sessions
     * @secure
     */
    sessionsList: (
      query?: {
        /** Date to retrieve data from */
        dateFrom?: string;
        /** Date to retrieve data to */
        dateTo?: string;
        /** affiliates, staff or students */
        page?: string;
        /** Only show results sponsored by this sponsor. If mine, the current logged in kerb will be used */
        sponsorID?: string;
        /** DLC key to filter on */
        dlcKey?: string;
        /** The index of the first record that should be returned, starting at 1 */
        from?: number;
        /** The index of the last record that should be returned (including) */
        to?: number;
        /** none or any of COMPLETED,NOT_COMPLETED,EXPIRED,EXPIRY_SOON,EXPIRY_NO_DATE,ERROR,NO_ERROR */
        status?: string;
        /** expired - filter on expired records. close - filter on records about to expire. noDate - no expiry date */
        entryYear?: number;
        /** graduate or undergraduate */
        personType?: string;
        /** if only one sessions must be retrieved. Helper for UI issue */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SessionsResponse, any>({
        path: `/admin/sessions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SessionsCsvList
     * @summary Get sessions presigned url for a csv file with this queries results
     * @request GET:/admin/sessions/csv
     * @secure
     */
    sessionsCsvList: (
      query?: {
        /** Date to retrieve data from */
        dateFrom?: string;
        /** Date to retrieve data to */
        dateTo?: string;
        /** affiliates, staff or students */
        page?: string;
        /** Only show results sponsored by this sponsor. If mine, the current logged in kerb will be used */
        sponsorID?: string;
        /** DLC key to filter on */
        dlcKey?: string;
        /** The index of the first record that should be returned, starting at 1 */
        from?: number;
        /** The index of the last record that should be returned (including) */
        to?: number;
        /** none or any of COMPLETED,NOT_COMPLETED,EXPIRED,EXPIRY_SOON,EXPIRY_NO_DATE,ERROR,NO_ERROR */
        status?: string;
        /** expired - filter on expired records. close - filter on records about to expire. noDate - no expiry date */
        entryYear?: number;
        /** graduate or undergraduate */
        personType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SessionsResponse, any>({
        path: `/admin/sessions/csv`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SessionsDetail
     * @summary Get session details
     * @request GET:/admin/sessions/{id}
     * @secure
     */
    sessionsDetail: (id: string, params: RequestParams = {}) =>
      this.request<Session, void>({
        path: `/admin/sessions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SessionsPageFiltersList
     * @summary Get page filters for admin screens
     * @request GET:/admin/sessions/page-filters
     * @secure
     */
    sessionsPageFiltersList: (params: RequestParams = {}) =>
      this.request<PageFilters, any>({
        path: `/admin/sessions/page-filters`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SessionsReEvaluateList
     * @summary Get session details, but also get it from Moira and LDap and other original sources
     * @request GET:/admin/sessions/re-evaluate
     * @secure
     */
    sessionsReEvaluateList: (
      query?: {
        /** if only one sessions must be retrieved. Helper for UI issue */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Session, void>({
        path: `/admin/sessions/re-evaluate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SponsorList
     * @summary Get possible sponsors
     * @request GET:/admin/sponsor
     * @secure
     */
    sponsorList: (
      query?: {
        /** Filter possible sponsors, can be (part of) name, surname, kerb, MIT-ID or email. */
        searchString?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Sponsors, any>({
        path: `/admin/sponsor`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SponsorUpdate
     * @summary Update sponsor of person
     * @request PUT:/admin/sponsor
     * @secure
     */
    sponsorUpdate: (data: SponsorUpdate, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/sponsor`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name StatsList
     * @summary Get stats
     * @request GET:/admin/stats
     * @secure
     */
    statsList: (
      query?: {
        /** Return stats for the past specified days - defaults to 7 */
        days?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Stats, any>({
        path: `/admin/stats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SuspendUpdate
     * @summary suspend an invite
     * @request PUT:/admin/suspend
     * @secure
     */
    suspendUpdate: (data: Suspend, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/suspend`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name VisitorsList
     * @summary Get visitors
     * @request GET:/admin/visitors
     * @secure
     */
    visitorsList: (
      query?: {
        /** The index of the first record that should be returned, starting at 1 */
        from?: number;
        /** The index of the last record that should be returned (including) */
        to?: number;
        /** Return active invites only - defaults to true */
        activeOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitorsResponse, any>({
        path: `/admin/visitors`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name VisitorsDetail
     * @summary Get visitor details
     * @request GET:/admin/visitors/{id}
     * @secure
     */
    visitorsDetail: (id: string, params: RequestParams = {}) =>
      this.request<VisitorInvite, any>({
        path: `/admin/visitors/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  lookup = {
    /**
     * No description
     *
     * @tags Lookup
     * @name DepartmentList
     * @summary Get a list of all departments
     * @request GET:/lookup/department
     * @secure
     */
    departmentList: (params: RequestParams = {}) =>
      this.request<Lookups, any>({
        path: `/lookup/department`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  csGoldUser = {
    /**
     * No description
     *
     * @name CsGoldUserList
     * @request GET:/cs-gold-user
     * @secure
     */
    csGoldUserList: (
      query: {
        mitId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CSGoldUser, any>({
        path: `/cs-gold-user`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SearchList
     * @request GET:/cs-gold-user/search
     * @secure
     */
    searchList: (
      query?: {
        name?: string;
        lastName?: string;
        middleName?: string;
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CSGoldUser[], any>({
        path: `/cs-gold-user/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  mobileId = {
    /**
     * No description
     *
     * @tags Mobile ID
     * @name MobileIdList
     * @summary Get common properties related to mobile ID
     * @request GET:/mobile-id
     * @secure
     */
    mobileIdList: (
      query?: {
        /** Name of the calling app, e.g. Atlas/TimTickets */
        appId?: string;
        /** Model of the device */
        deviceModel?: string;
        /** OS of the device */
        deviceOS?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MobileIdProfile, any>({
        path: `/mobile-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile ID
     * @name MobileIdCreate
     * @summary Record relevant device and application info
     * @request POST:/mobile-id
     * @secure
     */
    mobileIdCreate: (data: MobileIdRecord, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/mobile-id`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile ID
     * @name CbordAndroidCreate
     * @summary AuthenticateUserExternal, retrieveExternalAuthenticationToken, authorize, get active passes and create credential
     * @request POST:/mobile-id/cbord/android
     * @secure
     */
    cbordAndroidCreate: (
      data: CBordAndroidRequest,
      query?: {
        /** (optional) used for system to system call - specify mit id */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CBordAndroidResponse, BadRequestResponse>({
        path: `/mobile-id/cbord/android`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile ID
     * @name CbordAndroidCredentialUpdate
     * @summary Update a credential(usually the status or device).
     * @request PUT:/mobile-id/cbord/android/credential/{id}
     * @secure
     */
    cbordAndroidCredentialUpdate: (
      id: string,
      data: CBordCredentialUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CBordCredentialResponse, any>({
        path: `/mobile-id/cbord/android/credential/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile ID
     * @name CbordAndroidCredentialDelete
     * @summary Delete a credential.
     * @request DELETE:/mobile-id/cbord/android/credential/{id}
     * @secure
     */
    cbordAndroidCredentialDelete: (
      id: string,
      data: CBordCredentialDeleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<CBordCredentialResponse, any>({
        path: `/mobile-id/cbord/android/credential/${id}`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile ID
     * @name CbordAuthCreate
     * @summary AuthenticateUserExternal, retrieveAuthorizationBlob and get active passes
     * @request POST:/mobile-id/cbord/auth
     * @secure
     */
    cbordAuthCreate: (
      data: CBordAuthRequest,
      query?: {
        /** (optional) used for system to system call - specify mit id */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CBordAuthResponse, BadRequestResponse>({
        path: `/mobile-id/cbord/auth`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile ID
     * @name CbordUnlinkUpdate
     * @summary Request unlink for current device
     * @request PUT:/mobile-id/cbord/unlink
     * @secure
     */
    cbordUnlinkUpdate: (
      query?: {
        /** (optional) used for system to system call - specify mit id */
        mitId?: string;
        /**
         * Device type to unlink
         * @example "android,ios,watch"
         */
        deviceType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, BadRequestResponse>({
        path: `/mobile-id/cbord/unlink`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),
  };
  register = {
    /**
     * No description
     *
     * @tags Duo
     * @name DuoSignedRequestList
     * @summary Get a new duo signed request
     * @request GET:/register/duo/signed_request
     */
    duoSignedRequestList: (params: RequestParams = {}) =>
      this.request<DuoSignedRequest, any>({
        path: `/register/duo/signed_request`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Duo
     * @name DuoUserStatusList
     * @summary Get a new duo signed request
     * @request GET:/register/duo/user_status
     */
    duoUserStatusList: (params: RequestParams = {}) =>
      this.request<DuoUserStatus, any>({
        path: `/register/duo/user_status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Duo
     * @name DuoEnrollCreate
     * @summary Get a new duo signed request
     * @request POST:/register/duo/enroll
     */
    duoEnrollCreate: (data: DuoEnroll, params: RequestParams = {}) =>
      this.request<DuoEnrollResponse, any>({
        path: `/register/duo/enroll`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kerb
     * @name KerbCreate
     * @summary create a new kerb
     * @request POST:/register/kerb
     */
    kerbCreate: (data: KerbCreate, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/register/kerb`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kerb
     * @name KerbAvailableList
     * @summary check if a kerb name is available
     * @request GET:/register/kerb/available
     */
    kerbAvailableList: (
      query: {
        /** kerb to check' */
        krbName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KerbAvailable, any>({
        path: `/register/kerb/available`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kerb
     * @name KerbSuggestList
     * @summary get kerb name suggestions
     * @request GET:/register/kerb/suggest
     */
    kerbSuggestList: (params: RequestParams = {}) =>
      this.request<KerbSuggestions, any>({
        path: `/register/kerb/suggest`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Password
     * @name PasswordList
     * @summary get password status
     * @request GET:/register/password
     */
    passwordList: (params: RequestParams = {}) =>
      this.request<PasswordStatus, any>({
        path: `/register/password`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Password
     * @name PasswordCreate
     * @summary set a person's password
     * @request POST:/register/password
     */
    passwordCreate: (data: PasswordSet, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/register/password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Picture
     * @name PictureList
     * @summary Get the currently set picture
     * @request GET:/register/picture
     */
    pictureList: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/register/picture`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Picture
     * @name PictureCreate
     * @summary Uploads a profile picture.Content-Type': 'image/*'
     * @request POST:/register/picture
     */
    pictureCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/register/picture`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Picture
     * @name PictureUrlList
     * @summary Get a S3 Signed url for picture uploading
     * @request GET:/register/picture/url
     */
    pictureUrlList: (params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/register/picture/url`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StatusList
     * @summary get the current account creation progress
     * @request GET:/register/status
     */
    statusList: (params: RequestParams = {}) =>
      this.request<Status, any>({
        path: `/register/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TextList
     * @summary get all texts
     * @request GET:/register/text
     */
    textList: (params: RequestParams = {}) =>
      this.request<Texts, any>({
        path: `/register/text`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TokenEmailCreate
     * @summary Resend token email if token has expired
     * @request POST:/register/token/email
     */
    tokenEmailCreate: (data: TokenEmail, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/register/token/email`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  sponsoredAccount = {
    /**
     * No description
     *
     * @tags Sponsored Account
     * @name SponsoredAccountList
     * @summary Get all guest the logged in user has created.
     * @request GET:/sponsored-account
     * @secure
     */
    sponsoredAccountList: (
      data: SponsoredGuestCreated,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/sponsored-account`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sponsored Account
     * @name RenewalList
     * @summary Get all sponsored accounts that are able to be renewed
     * @request GET:/sponsored-account/renewal
     * @secure
     */
    renewalList: (data: SponsoredGuestCreated, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/sponsored-account/renewal`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sponsored Account
     * @name RenewalUpdate
     * @summary Renew a list of sponsored accounts. Processes async
     * @request PUT:/sponsored-account/renewal
     * @secure
     */
    renewalUpdate: (
      data: RenewSponsoredAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/sponsored-account/renewal`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sponsored Account
     * @name ReassignSponsorList
     * @summary Get all sponsored acocunts that have been requested to be reassigned for the calling user
     * @request GET:/sponsored-account/reassign-sponsor
     * @secure
     */
    reassignSponsorList: (
      data: ReassignedSponsoredAccount,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/sponsored-account/reassign-sponsor`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sponsored Account
     * @name ReassignSponsorCreate
     * @summary Assign another sponsor for sponsored account. Pending approval
     * @request POST:/sponsored-account/reassign-sponsor
     * @secure
     */
    reassignSponsorCreate: (
      data: SponsoredGuestNewSponsor,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/sponsored-account/reassign-sponsor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sponsored Account
     * @name ReassignSponsorUpdate
     * @summary Approve or reject reassignment of sponsor
     * @request PUT:/sponsored-account/reassign-sponsor/{mitId}
     * @secure
     */
    reassignSponsorUpdate: (
      mitId: string,
      query: {
        /** The mitId of the user to approve/reject new sponsor */
        mitId: string;
      },
      data: SponsoredGuestReassign,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/sponsored-account/reassign-sponsor/${mitId}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sponsored Account
     * @name GuestCreate
     * @summary Register a sponsored guest.
     * @request POST:/sponsored-account/guest
     * @secure
     */
    guestCreate: (data: SponsoredGuest, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/sponsored-account/guest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sponsored Account
     * @name StatusList
     * @summary Get sponsored account steps along with status of steps.
     * @request GET:/sponsored-account/{mitId}/status
     * @secure
     */
    statusList: (
      mitId: string,
      data: SponsoredAccountStepStatus,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/sponsored-account/${mitId}/status`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sponsored Account
     * @name SponsoredAccountDetail
     * @summary Get additional details about sponsored account
     * @request GET:/sponsored-account/{mitId}
     * @secure
     */
    sponsoredAccountDetail: (
      mitId: string,
      data: SponsoredGuestAdditionalDetails,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/sponsored-account/${mitId}`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sponsored Account
     * @name SpouseCreate
     * @summary Register a spouse.
     * @request POST:/sponsored-account/spouse
     * @secure
     */
    spouseCreate: (data: SponsoredSpouse, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/sponsored-account/spouse`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sponsored Account
     * @name AuthorizationList
     * @summary Get sponsored account authorizations for the logged in user
     * @request GET:/sponsored-account/authorization
     * @secure
     */
    authorizationList: (params: RequestParams = {}) =>
      this.request<SponsoredAccountAuths, any>({
        path: `/sponsored-account/authorization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name PasswordList
     * @summary get password status for a user
     * @request GET:/user/password
     * @secure
     */
    passwordList: (params: RequestParams = {}) =>
      this.request<PasswordStatus, any>({
        path: `/user/password`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name PasswordCreate
     * @summary password set for user
     * @request POST:/user/password
     * @secure
     */
    passwordCreate: (data: PasswordChange, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/user/password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name SearchList
     * @summary Search for users based on parameters. 100 results max
     * @request GET:/user/search
     * @secure
     */
    searchList: (
      query: {
        /** The search string. Can be the first vew characters of the name */
        search: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserProfile[], any>({
        path: `/user/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile ID, User
     * @name MobileIdList
     * @summary Get common properties related to mobile ID for a specific user
     * @request GET:/user/{mitId}/mobile-id
     * @secure
     */
    mobileIdList: (mitId: string, params: RequestParams = {}) =>
      this.request<MobileIdProfile, any>({
        path: `/user/${mitId}/mobile-id`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name DuoSignedRequestList
     * @summary Duo User - Get a new duo signed request
     * @request GET:/user/duo/signed_request
     * @secure
     */
    duoSignedRequestList: (params: RequestParams = {}) =>
      this.request<DuoSignedRequest, any>({
        path: `/user/duo/signed_request`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name DuoUserStatusList
     * @summary Duo User - Get a new duo signed request
     * @request GET:/user/duo/user_status
     * @secure
     */
    duoUserStatusList: (params: RequestParams = {}) =>
      this.request<DuoUserStatus, any>({
        path: `/user/duo/user_status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name DuoEnrollCreate
     * @summary Duo User - Get a new duo signed request
     * @request POST:/user/duo/enroll
     * @secure
     */
    duoEnrollCreate: (data: DuoEnroll, params: RequestParams = {}) =>
      this.request<DuoEnrollResponse, any>({
        path: `/user/duo/enroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name PictureList
     * @summary Get a user picture with status
     * @request GET:/user/picture
     * @secure
     */
    pictureList: (
      query?: {
        /** Specify the image resolution. */
        resolution?: "low" | "high";
        /** Get picture for kerberos name */
        krbName?: string;
        /** Get picture for MIT ID */
        mitId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserPicture, any>({
        path: `/user/picture`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name PictureUrlList
     * @summary Get a S3 Signed url for picture uploading
     * @request GET:/user/picture/url
     * @secure
     */
    pictureUrlList: (params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/user/picture/url`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name PictureUpdate
     * @summary Get a picture validation result
     * @request PUT:/user/picture/{id}
     * @secure
     */
    pictureUpdate: (id: string, params: RequestParams = {}) =>
      this.request<PictureValidate, any>({
        path: `/user/picture/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name CardList
     * @summary Get a user mit id card and status
     * @request GET:/user/card
     * @secure
     */
    cardList: (params: RequestParams = {}) =>
      this.request<UserMitIdCard, any>({
        path: `/user/card`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  test = {
    /**
     * No description
     *
     * @tags Test
     * @name CreatemitCreate
     * @summary create a new user
     * @request POST:/test/createmit
     * @secure
     */
    createmitCreate: (data: TestCreateMitRequest, params: RequestParams = {}) =>
      this.request<TestCreateMit, any>({
        path: `/test/createmit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name ResetCreate
     * @summary reset a test user
     * @request POST:/test/reset
     * @secure
     */
    resetCreate: (data: TestReset, params: RequestParams = {}) =>
      this.request<void, BadRequestResponse>({
        path: `/test/reset`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name StatsList
     * @summary Get stats
     * @request GET:/test/stats
     * @secure
     */
    statsList: (params: RequestParams = {}) =>
      this.request<Stats, any>({
        path: `/test/stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name TokenList
     * @summary generate a jwt token for testing
     * @request GET:/test/token
     * @secure
     */
    tokenList: (
      query: {
        /** mit id to get */
        mitId: string;
        /** send email too */
        sendEmail?: boolean;
        /** make expired token */
        expired?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestTokenResponse, any>({
        path: `/test/token`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name Testkrb5List
     * @summary Invoke a command on KRB5 layer to ensure it is deployed and working
     * @request GET:/test/testkrb5
     * @secure
     */
    testkrb5List: (
      query: {
        /** Kerb Name to check if it is available */
        krbName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestKrb5Response, any>({
        path: `/test/testkrb5`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name UsersList
     * @summary get list of test users
     * @request GET:/test/users
     * @secure
     */
    usersList: (params: RequestParams = {}) =>
      this.request<TestUsers, any>({
        path: `/test/users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  ui = {
    /**
     * No description
     *
     * @tags ui
     * @name CardsList
     * @summary Fetch the data needed to build up any account related UI cards
     * @request GET:/ui/cards
     * @secure
     */
    cardsList: (
      query?: {
        krbName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CardsData, any>({
        path: `/ui/cards`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  vcs = {
    /**
     * No description
     *
     * @name PostVcs
     * @summary Update allocation.
     * @request POST:/vcs
     * @secure
     */
    postVcs: (data: VCS, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/vcs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  apiHealth = {
    /**
     * @description Is the API reachable
     *
     * @name PingList
     * @request GET:/api-health/ping
     * @secure
     */
    pingList: (params: RequestParams = {}) =>
      this.request<ApiHealthPingResponse, any>({
        path: `/api-health/ping`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Can the API connect to all the various integrations that it should be able to
     *
     * @name StatusList
     * @request GET:/api-health/status
     * @secure
     */
    statusList: (params: RequestParams = {}) =>
      this.request<ApiStatusResponse, any>({
        path: `/api-health/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
